import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	alerts: {
		id: 'navigation-apps-sidebar-nav4-operations.alerts',
		defaultMessage: 'Alerts',
		description: 'Assets dropdown item to link customer to Operations Alerts page.',
	},
});
